import React, { useEffect, useState } from 'react';
import SafeIcon from '../../common/SafeIcon';

export default function MoxieEmbed({
  id,
  title,
  src,
  fallbackUrl,
  fallbackLabel,
  minHeight,
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadTimedOut, setLoadTimedOut] = useState(false);

  useEffect(() => {
    if (isLoaded) return undefined;

    const timeout = window.setTimeout(() => {
      setLoadTimedOut(true);
    }, 12000);

    return () => window.clearTimeout(timeout);
  }, [isLoaded]);

  return (
    <div>
      <div className="relative overflow-hidden rounded-2xl border border-[#244A49]/10 bg-white shadow-widget">
        {!isLoaded && (
          <div
            className="absolute inset-x-0 top-0 z-10 flex min-h-40 items-center justify-center bg-white"
            role="status"
          >
            <div className="flex items-center gap-3 text-sm font-semibold text-[#244A49]">
              <span className="h-5 w-5 animate-spin rounded-full border-2 border-[#409FA1]/20 border-t-[#409FA1]" />
              Loading secure Moxie experience…
            </div>
          </div>
        )}

        <iframe
          id={id}
          title={title}
          src={src}
          className="block w-full border-0 bg-white"
          style={{ minHeight, height: minHeight }}
          scrolling="auto"
          onLoad={() => {
            setIsLoaded(true);
            setLoadTimedOut(false);
          }}
        />
      </div>

      <div className="mt-4 flex flex-wrap items-center justify-between gap-3 px-1">
        <p className="text-xs leading-5 text-[#244A49]">
          {loadTimedOut
            ? 'The calendar is taking longer than expected.'
            : 'Scheduling is securely hosted by Moxie.'}
        </p>
        <a
          href={fallbackUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex min-h-11 items-center gap-2 text-sm font-bold text-[#244A49] underline underline-offset-4"
        >
          {fallbackLabel}
          <SafeIcon name="ArrowUpRight" className="h-4 w-4" />
        </a>
      </div>
    </div>
  );
}